<template>
  <el-form ref="form" label-position="top" class="app-container view-container" :model="form" :rules="rules" label-width="120px">
    <template>
        <BjDivider>
        {{ $t('BusinessPurchaseComponentsPur.type') }}
        <template #button>
        <div class="ml5 mt20">
          <el-form-item prop="purchaseType">
            <BjSelectLov v-model="form.purchaseType" :disabled="isEdit" :option-list="PURCHASE_TYPE" @change="changeLov" />
          </el-form-item>
          </div>
        </template>
        <template #right>
          <el-button @click="handleClose">{{ $t('cancelText') }}</el-button>
          <el-button type="primary" @click="handleConfirm">{{ $t('okText') }}</el-button>
        </template>

      </BjDivider>
    </template>
    <template>
      <BjDivider>
        {{ $t('BusinessPurchaseComponentsCom.PO.title') }}
        <template v-if="!isEdit">
          <el-button type="primary" :disabled="!form.purchaseType" @click="addPurchase">{{ $t('BusinessPurchaseComponentsCom.PO.selectPurchase') }}</el-button>
          <!-- <el-button @click="onNoPurchase">{{ $t('BusinessPurchaseComponentsCom.PO.noPurchase') }}{{ text() }}</el-button> -->
        </template>
      </BjDivider>
      <el-table v-if="isPurchase" :data="form.orderList" border script max-height="600">
        <el-table-column prop="code" :label="$t('BusinessPurchaseComponentsCom.PO.code')" width="180" align="center" />
        <el-table-column prop="typeMeaning" width="120" :label="$t('BusinessPurchaseComponentsCom.PO.typeMeaning')" align="center" />
        <el-table-column prop="statusMeaning" width="100" :label="$t('BusinessPurchaseComponentsCom.PO.statusMeaning')" align="center" />
        <el-table-column prop="stockinStatusMeaning" width="120" :label="$t('BusinessPurchaseComponentsCom.PO.stockinStatusMeaning')" align="center" />
        <el-table-column prop="supplierName" width="100" :label="$t('BusinessPurchaseComponentsCom.PO.supplierName')" align="center" />
        <el-table-column prop="creationDate" :label="$t('table.createTimeText')" align="center" width="140" />
        <!-- <el-table-column prop="warehouseName" width="160" :label="$t('BusinessPurchaseComponentsCom.PO.warehouseName')" align="center" /> -->
        <el-table-column prop="planQty" width="140" :label="$t('BusinessPurchaseComponentsCom.PO.planQty')" align="center" />
        <el-table-column prop="amount" width="170" :label="$t('BusinessPurchaseComponentsCom.PO.amount')" align="center" />
        <el-table-column prop="alreadyQty" width="140" :label="$t('BusinessPurchaseComponentsCom.PO.alreadyQty')" align="center" />
        <el-table-column prop="cancelQty" width="160" :label="$t('BusinessPurchaseComponentsCom.PO.cancelQty')" align="center" />
        <el-table-column prop="remark" :label="$t('table.remarkText')" align="center" />
        <el-table-column prop="buyerName" width="100" :label="$t('BusinessPurchaseComponentsCom.PO.buyerName')" align="center" />
      </el-table>
    </template>
    <template>
      <BjDivider>
        {{ $t('BusinessPurchaseComponentsCom.baseMsg.title') }}
      </BjDivider>
      <el-row>
        <el-col :span="colSpan">
          <el-form-item :label="`${text(2)}${$t('BusinessPurchaseComponentsCom.baseMsg.oddNumber')}`" prop="code">
            <BjInput
              v-model="form.code"
              disabled
              :placeholder="$t('BusinessPurchaseComponentsCom.baseMsg.automatic')"
              :maxlength="MAX_LENGTH.DEFAULT"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="`${text(2)}${$t('BusinessPurchaseComponentsCom.baseMsg.type')}`" prop="type">
            <BjSelectLov
              v-model="form.type"
              :disabled="isPurchase"
              :lov-code="enter ? 'SPUR.STOCKIN_TYPE' : 'SPUR.STOCKOUT_TYPE'"
            />
          </el-form-item>
        </el-col>
         <el-col :span="colSpan">
          <el-form-item :label="$t('table.statusText')" prop="status">
            <BjInput
              v-model="form.status"
              disabled
              :maxlength="MAX_LENGTH.DEFAULT"
            />
          </el-form-item>
        </el-col>
        <!-- <el-col :span="colSpan">
          <el-form-item :label="`${text()}${$t('BusinessPurchaseComponentsCom.baseMsg.warehouse')}`" prop="warehouseCode">
            <BjSelectWarehouse
              v-model="form.warehouseCode"
              value-code="code"
              :type-code="['logic']"
              @change="onChangeWarehouse"
            />
          </el-form-item>
        </el-col> -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseComponentsCom.baseMsg.supplier')" prop="supplierCode">
            <BjSelectSupplier
              v-model="form.supplierCode"
              option-value="code"
              :default-options="{
                label: form.supplierName,
                value: form.supplierCode,
              }"
              :disabled="isPurchase || isEdit"
              @change="onChangeSupplier"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseComponentsPur.postingDate')" prop="postingDate">
            <BjDatePicker v-model="form.postingDate" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseComponentsPur.expectedDate')" prop="requiredDate">
            <BjDatePicker v-model="form.requiredDate" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseComponentsPur.documentDate')" prop="documentDate">
            <BjDatePicker v-model="form.documentDate" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseComponentsCom.invoiceNo')" prop="invoiceNo">
            <BjInput v-model="form.invoiceNo" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseComponentsPur.vendorRefNo')" prop="vendorRefNo">
            <BjInput v-model="form.vendorRefNo" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseComponentsPur.remark')" prop="remark">
            <BjInput v-model="form.remark" autosize type="textarea" show-word-limit :placeholder="$t('table.remarkText')" />
          </el-form-item>
        </el-col>
      </el-row>
    </template>
    <template>
      <div class="bj-row" style="margin-bottom:0;">
      <BjDivider>
        {{ $t('BusinessPurchaseComponentsCom.commodityMsg.title') }}
        <template>
          <!-- <el-button type="primary" @click="addStorageShop">{{ $t('BusinessPurchaseComponentsCom.commodityMsg.add') }}{{ text() }}{{ $t('BusinessPurchaseComponentsCom.commodityMsg.commodity') }}</el-button> -->
          <el-button :disabled="!form.supplierCode" type="primary" @click="onImport">{{ $t('EXCELImportText') }}</el-button>
          <el-button type="warning" plain :disabled="selection.length === 0" @click="onDelete()">{{ $t('delText') }}</el-button>
          <el-button v-if="!spreadVisible" type="warning" :disabled="selection.length === 0" plain @click="onPackUp">{{ $t('BusinessPurchaseComponentsCom.onPackUpBtn') }}</el-button>
          <el-button v-else type="warning" plain @click="onSpread">{{ $t('BusinessPurchaseComponentsCom.onSpreadBtn') }}</el-button>
        </template>
      </BjDivider>
      <div class="bj-col bj-col-24" style="border-left:none;">
          <el-table :row-class-name="tableRowClassName" :data="form.goodsList" border script max-height="600px" @selection-change="handleSelectionChange">
            <el-table-column :label="$t('table.countText')" type="index" width="65" fixed="left" align="center" />
            <el-table-column type="selection" width="70" align="center" fixed="left" />
            <el-table-column :label="$t('BusinessPurchaseComponentsCom.PO.code')" prop="code" align="center" width="175" />
            <el-table-column prop="skuCode" label="SKU" align="center" width="160">
            </el-table-column>
            <el-table-column prop="temporaryQty" :label="$t('BusinessPurchaseComponentsCom.alreadyQty')" align="center" width="155">
              <template slot-scope="{ row }">
                <BjInputNumber v-model="row.temporaryQty" :min="0" class="full-width" :controls="false" />
              </template>
            </el-table-column>
            <el-table-column prop="taxUnitPrice" :label="$t('BusinessPurchaseComponentsPur.table.UnitPrice')" align="center" width="120">
              <template slot-scope="{ row }">
                <BjInputMoney v-model="row.taxUnitPrice" :min="0" class="full-width" :controls="false"></BjInputMoney>
              </template>
            </el-table-column>
            <el-table-column prop="planQty" :label="$t('BusinessPurchaseComponentsCom.allPlanQty')" align="center" width="125">
            </el-table-column>
            <el-table-column prop="alreadyQty" :label="$t('BusinessStockEntryResult.table.alreadyQty')" align="center" width="75">
            </el-table-column>
            <el-table-column prop="waitQty" :label="$t('BusinessPurchaseEntryComPage.table.waitQty')" align="center" width="100">
            </el-table-column>
            <el-table-column prop="discount" :label="$t('BusinessPurchaseComponentsPur.table.Discount')" align="center" width="130">
              <template slot-scope="{ row }">
                <BjInputNumber v-model="row.discount" :placeholder="$t('chooseText')">
                  <template slot="append">%</template>
                </BjInputNumber>
              </template>
            </el-table-column>
            <el-table-column prop="taxCode" :label="$t('BusinessPurchaseComponentsPur.table.TaxCode')" align="center" width="100">
              <template slot-scope="{ row }">
                <el-select v-model="row.taxCode">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="grossPriceAfterDisc" :label="$t('BusinessPurchaseComponentsPur.table.GrosSprice')" align="center" width="132">
            </el-table-column>
            <el-table-column prop="totalPrice" :label="$t('BusinessPurchaseComponentsPur.table.Total')" align="center" width="140">
            </el-table-column>
            <el-table-column :label="$t('BusinessPurchaseComponentsPur.table.Warehouse')" align="center" width="130">
              <template slot-scope="{ row }">
                <BjSelectWarehouse v-model="row.warehouse" value-code="code" :type-code="['logic']" />
              </template>
            </el-table-column>
            <el-table-column prop="length" :label="$t('BusinessPurchaseComponentsPur.table.Length')" align="center" width="130">
              <template slot-scope="{ row }">
                {{ row.length }} cm
              </template>
            </el-table-column>
            <el-table-column prop="width" :label="$t('BusinessPurchaseComponentsPur.table.Width')" align="center" width="130">
              <template slot-scope="{ row }">
                {{ row.width }} cm
              </template>
            </el-table-column>
            <el-table-column prop="height" :label="$t('BusinessPurchaseComponentsPur.table.Height')" align="center" width="130">
              <template slot-scope="{ row }">
                {{ row.height }} cm
              </template>
            </el-table-column>
            <el-table-column prop="volume" :label="$t('BusinessPurchaseComponentsPur.table.Volume')" align="center" width="130">
              <template v-slot="{ row }">
                {{ row.length * row.width * row.height }}
              </template>
            </el-table-column>
            <el-table-column prop="volumeUnit" :label="$t('BusinessPurchaseComponentsPur.table.VolumeUnit')" align="center" width="120">
              cm³
            </el-table-column>
            <el-table-column prop="weight" :label="$t('BusinessPurchaseComponentsPur.table.Weight')" align="center" width="130">
              <template slot-scope="{ row }">
                {{ row.weight }} kg
              </template>
            </el-table-column>
            <el-table-column prop="uomCode" :label="$t('BusinessPurchaseComponentsPur.table.UomCode')" align="center" width="130">
              <template slot-scope="{ row }">
                <BjInput v-model="row.uomCode" :min="0" class="full-width" :controls="false" />
              </template>
            </el-table-column>
            <el-table-column prop="" :label="$t('table.operationText')" align="center" fixed="right" width="120">
              <template slot-scope="{ row, $index }">
                <el-button @click="onDelete(row, $index)">{{ $t('delText') }}</el-button>
              </template>
            </el-table-column>
          </el-table>
        <div v-if="form.goodsList.length" class="bj-form-tips" style="margin-top: 15px">
          <div>
            <span class="mr20">Total Before Discount: <span class="font16 ml10">{{ totalBefore }}</span></span>  Total Payment Due:<span class="font16 ml10">{{ totalPayment }}</span>  <span class="ml25"></span> Tax:
            <span class="font16 ml10">{{ taxComputed }} </span>
          </div>
        </div>
    </div>
    <template v-if="form.purchaseType!=='COMMON'&& form.goodsList.length>0">
      <BjDivider>{{ $t('BusinessPurchaseComponentsPur.table.FreightInformation') }}</BjDivider>
        <el-table border script max-height="600px" :data="freight">
          <el-table-column prop="freightName" :label="$t('BusinessPurchaseComponentsPur.table.FreightName')" align="center" width="130"></el-table-column>
          <el-table-column prop="taxGroup" :label="$t('BusinessPurchaseComponentsPur.table.TaxGroup')" align="center">
            <template slot-scope="{ row }">
                <el-select v-model="row.taxGroup" @change="taxChange">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="tax" :label="$t('BusinessPurchaseComponentsPur.table.Tax')" align="center"></el-table-column>
          <el-table-column prop="netAmount" :label="$t('BusinessPurchaseComponentsPur.table.NetAmount')" align="center" width="160">
            <template slot-scope="{ row }">
              <el-input-number v-model="row.netAmount" :min="0" class="full-width" :controls="false" @change="autoNetAmount(row)">
                <template slot="prepend">AUD</template>
              </el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="distribMethod" :label="$t('BusinessPurchaseComponentsPur.table.DistribMethod')" align="center">
            <template slot-scope="{ row }">
              {{ row.distribMethod }}
            </template>
          </el-table-column>
          <el-table-column prop="totalTax" :label="$t('BusinessPurchaseComponentsPur.table.TotalTaxAmount')" align="center" width="160">
            <template slot-scope="{ row }">
              <el-input-number v-model="row.totalTaxAmount" :min="0" :disabled="row.tax===0" class="full-width" :controls="false" @change="autoTotalTaxAmount(row)">
                <template slot="prepend">AUD</template>
              </el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="status" :label="$t('table.statusText')" align="center" width="120"></el-table-column>
          <el-table-column prop="grossAmount" :label="$t('BusinessPurchaseComponentsPur.table.GrossAmount')" align="center" width="160">
            <template slot-scope="{ row }">
              <el-input-number v-model="row.grossAmount" :min="0" class="full-width" :controls="false" @change="autoGrossAmount(row)">
                <template slot="prepend">AUD</template>
              </el-input-number>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </div>
    </template>
    <BjDialogList
      ref="dialogOrderList"
      :multiple="isPurchaseType"
      width="80%"
      :config="
        $BjDialogListConfig['purchaseOrderDefault']($t('BusinessPurchaseComponentsCom.bjDialogText'), {
          defaultQuery: {
            statusList: enter ? 'IN_PROD' : 'WAIT_STOCKIN,COMPLETED',
            type: queryPurchaseType,
          },
        })
      "
      tag-name="code"
      @confirm="onAddDialogConfirm"
    />

    <BjDialogList
      ref="dialogGoodsList"
      width="80%"
      :config="dialogGoodsConfig"
      multiple
      @confirm="onAddDialogGoodsConfirm"
    />
    <BjDialogList
      ref="dialogPurchaseGoodsList"
      width="80%"
      res="goodsList"
      is-list
      search-btn-hide
      :config="dialogPurchaseGoodsConfig"
      multiple
      @confirm="onAddDialogGoodsConfirm"
    >
      <template #tableTop>
        <p class="mb16">{{ $t('BusinessPurchaseComponentsCom.purchaseCode') }}：{{ form.purchaseCode }}</p>
      </template>
    </BjDialogList>
    <!-- EXCEL导入 -->
    <ExcelImportDialog ref="ExcelImport" :purchase-data-list="form.goodsList" @submit="getTableData" />
  </el-form>
</template>
<script>
import {purchaseApi} from '@/api';
import {maxToFixed} from '@/utils';
import {purchaseDefaultSearch} from '@/utils/BjDialogListConfig';
import ExcelImportDialog from '../entry/components/ExcelImportDialog';
import BjInputNumber from '@/packages/BjInputNumber';
import BjInputMoney from '@/packages/BjInputMoney';
import BjDivider from '@/packages/BjDivider';
import { PURCHASE_TYPE } from '@/utils/constants';

const defaultForm = () => {
  return {
    purchaseType: null,
    status: 'open',
    type: null, // 默认填充：采购入库  锁死不可修改
    orderList: [],
    goodsList: [],
    id: null,
    logisticsBusinessCode: null,
    logisticsBusinessId: null,
    logisticsBusinessName: null,
    logisticsNo: null,
    objectVersionNumber: null,
    purchaseCode: null,
    applyCode: null,
    recipientAddress: null,
    recipientCity: null,
    recipientCityCode: null,
    recipientDistrict: null,
    recipientDistrictCode: null,
    recipientName: null,
    recipientPhone: null,
    recipientProvince: null,
    recipientProvinceCode: null,
    remark: '',
    source: 'MANUAL',
    supplierCode: null,
    supplierName: null,
    thirdCode: null,
    warehouseCode: null,
    warehouseName: null,
    countryName: null,
    countryCode: null,
    postcode: null,
    documentDate: null,
    postingDate: null,
    requiredDate: null,
    invoiceNo: null,
    vendorRefNo: null,
  };
};
export default {
  name: '',
  components: {BjDivider, BjInputNumber, BjInputMoney, ExcelImportDialog },
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    enter: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      PURCHASE_TYPE,
      // 是否关联采购入库
      isPurchase: true,
      // 关联采购单类型[国内 or 澳州(默认)]
      isPurchaseType: false,
      colSpan: 8,
      form: defaultForm(),
      regionList: [],
      selection: [],
      queryPurchaseType: 'FREE_GIFT',
      options: [
        {
            value: 'p1',
            label: 'p1'
        },
        {
            value: 'p2',
            label: 'p2'
        }
      ],
      freight: [
        {
        freightName: 'FREIGHT',
        taxGroup: 'p1',
        tax: 10,
        totalTaxAmount: 0,
        distribMethod: 'Row Total',
        netAmount: 0,
        status: 'O',
        grossAmount: 0,
      }
      ],
      packUpGoodsList: [], // 存放收起空项时的原始数据
      spreadVisible: false,
    };
  },
  computed: {
    taxComputed() {
      // eslint-disable-next-line no-return-assign
      const totalPrice = this.form.goodsList.reduce((pre, item) => {
        // eslint-disable-next-line no-return-assign
        return pre += (item.taxCode === 'p1' ? Number(item.totalPrice * 1.1) : Number(item.totalPrice));
      }, 0);
      return totalPrice.toFixed(3);
    },
    totalPayment () {
      // eslint-disable-next-line no-return-assign
      const result = this.form.goodsList.reduce((pre, item) => pre += Number(item.totalPrice), 0);
      return Number(result).toFixed(3);
    },
    totalBefore() {
      // eslint-disable-next-line no-return-assign
      const result = this.form.goodsList.reduce((pre, item) => pre += (item.temporaryQty * item.taxUnitPrice), 0);
      return isNaN(result) ? '' : Number(result).toFixed(3);
    },
    rules() {
      const validateFullAddress = (rule, value, callback) => {
        this.$nextTick(() => {
          if (!this.form.countryCode || !this.form.recipientProvinceCode) {
            callback(new Error(this.$t('WarehouseManagement.form.Please')));
          }
          callback();
        });
      };
      return {
          purchaseType: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
          type: [{ required: true, message: this.$t('BusinessPurchaseComponentsCom.rules.type'), trigger: 'change' }],
          warehouseCode: [{ required: true, message: this.$t('BusinessPurchaseComponentsCom.rules.warehouseCode'), trigger: 'change' }],
          supplierCode: [{ required: true, message: this.$t('BusinessPurchaseComponentsCom.rules.supplierCode'), trigger: 'change' }],
          logisticsBusinessId: [{ required: true, message: this.$t('BusinessPurchaseComponentsCom.rules.logisticsBusinessId'), trigger: 'change' }],
          planQty: [{ required: true, message: this.$t('BusinessPurchaseComponentsCom.rules.planQty'), trigger: 'blur' }],
          taxUnitPrice: [{ required: true, message: this.$t('BusinessPurchaseComponentsCom.rules.taxUnitPrice'), trigger: 'blur' }],
          taxRate: [{ required: true, message: this.$t('BusinessPurchaseComponentsCom.rules.taxRate'), trigger: 'blur' }],
          fullAddress: { required: true, validator: validateFullAddress, trigger: 'change' },
          recipientCity: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
          invoiceNo: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
          recipientDistrict: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
          recipientAddress: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
          postcode: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
          requiredDate: [{required: true, message: this.$t('chooseText'), trigger: 'change'}],
          documentDate: [{required: true, message: this.$t('chooseText'), trigger: 'change'}],
          postingDate: [{required: true, message: this.$t('chooseText'), trigger: 'change'},
        ],
      };
    },
    dialogGoodsConfig() {
      purchaseDefaultSearch[0].disabled = true;
      purchaseDefaultSearch[1].disabled = true;
      return this.$BjDialogListConfig['purchaseGoodsDefault'](`${this.$t('BusinessPurchaseComponentsCom.choosePurchase')} ${this.text()} ${this.$t('BusinessPurchaseComponentsCom.commodity')}`, {
        search: purchaseDefaultSearch,
        defaultQuery: {
          supplierName: this.form.supplierName,
          supplierCode: this.form.supplierCode,
        },
      });
    },
    dialogPurchaseGoodsConfig() {
      return this.$BjDialogListConfig['purchaseOrderDefault'](`${this.$t('BusinessPurchaseComponentsCom.choosePurchase')} ${this.text()} ${this.$t('BusinessPurchaseComponentsCom.commodity')}`, {
        actionApi: purchaseApi.getPurchasesDetail,
        columns: [
          {prop: 'skuName', label: this.$t('BusinessPurchaseComponentsCom.skuName')},
          {prop: 'skuCode', label: this.$t('BusinessPurchaseComponentsCom.skuCode')},
          {prop: 'planQty', label: this.$t('BusinessPurchaseComponentsCom.planQty')},
          {prop: 'waitQty', label: this.$t('BusinessPurchaseComponentsCom.waitQty')},
          {prop: 'taxUnitPrice', label: this.$t('BusinessPurchaseComponentsCom.taxUnitPrice')},
          {prop: 'taxRate', label: this.$t('BusinessPurchaseComponentsCom.taxRate'), after: '%'},
          {prop: 'supplierSpuCode', label: this.$t('BusinessPurchaseComponentsCom.supplierSpuCode')},
        ],
        search: [],
        defaultQuery: {
          code: this.form.purchaseCode,
        },
      });
    },
  },
  watch: {
    'form.goodsList': {
      deep: true,
      immediate: true,
      handler: function(newVal, oldVal) {
        newVal.forEach((item, index) => {
          this.$watch(
            () => item.discount,
            function (newVal, oldVal) {
              const { taxUnitPrice, temporaryQty } = item;
              this.form.goodsList[index].grossPriceAfterDisc = Number((taxUnitPrice * ((100 - newVal) / 100))).toFixed(2);
              this.form.goodsList[index].totalPrice = Number(taxUnitPrice * ((100 - newVal) / 100) * temporaryQty).toFixed(2);
            }
          );
          this.$watch(
            () => item.taxUnitPrice,
            function (newVal, oldVal) {
              const { discount, grossPriceAfterDisc, temporaryQty } = item;
              this.form.goodsList[index].grossPriceAfterDisc = Number((newVal * ((100 - discount) / 100))).toFixed(2);
              this.form.goodsList[index].totalPrice = Number(grossPriceAfterDisc * temporaryQty).toFixed(2);
            }
          );
          this.$watch(
            () => item.temporaryQty,
            function (newVal, oldVal) {
              this.form.goodsList[index].totalPrice = Number(this.form.goodsList[index].grossPriceAfterDisc * newVal).toFixed(2);
            }
          );
        });
      }
      },
    'form.orderList': {
      handler: function(newVal, oldVal) {
        if (newVal) {
          const result = [];
          newVal.forEach(v => {
            result.push(v.code);
          });
          this.form.remark = `Based on Purchase quotations ${result.join(',')}`;
        }
      }
    },
    'form.purchaseType': {
      handler(val) {
        if (val === 'COMMON') {
          this.isPurchaseType = true;
          this.queryPurchaseType = 'COMMON';
        } else {
          this.isPurchaseType = false;
          this.queryPurchaseType = 'FREE_GIFT';
        }
        this.form.orderList = [];
        this.packUpGoodsList = [];
        this.spreadVisible = false;
      }
    },
    regionList(value) {
      this.form.countryCode = (value || [])[0];
      this.form.recipientProvinceCode = (value || [])[1];
    },
  },
  mounted() {
    if (this.isEdit) this.getData();
  },
  methods: {
    // 展开空项
    onSpread() {
      this.form.goodsList = this.packUpGoodsList;
      this.spreadVisible = false;
    },
    // 收起空项
    onPackUp() {
      this.packUpGoodsList = this.$lodash.clone(this.form.goodsList);
      this.form.goodsList = this.form.goodsList.filter(item => !this.selection.some(e => e.skuCode === item.skuCode && e.code === item.code));
      this.spreadVisible = true;
    },
    taxChange(v) {
      if (v === 'p2') {
        this.freight[0].tax = 0;
        this.freight[0].totalTaxAmount = 0;
        this.freight[0].grossAmount = this.freight[0].netAmount;
      } else {
        this.freight[0].tax = 10;
        this.freight[0].totalTaxAmount = this.freight[0].netAmount * 0.1;
        this.freight[0].grossAmount = (this.freight[0].netAmount * 1.1).toFixed(2);
      }
    },
    autoGrossAmount(row) {
      if (row.taxGroup === 'p1') {
          row.totalTaxAmount = (row.grossAmount * (1 / 11)).toFixed(2);
          row.netAmount = (row.grossAmount * (10 / 11)).toFixed(2);
      } else {
          row.totalTaxAmount = 0;
          row.netAmount = row.grossAmount;
      }
    },
    autoTotalTaxAmount(row) {
      row.netAmount = (row.totalTaxAmount * 10).toFixed(2);
      row.grossAmount = (row.totalTaxAmount * 11).toFixed(2);
    },
    autoNetAmount(row) {
      if (row.taxGroup === 'p1') {
          row.totalTaxAmount = (row.netAmount * 0.1).toFixed(2);
          row.grossAmount = (row.netAmount * 1.1).toFixed(2);
      } else {
          row.totalTaxAmount = 0;
          row.grossAmount = row.netAmount;
      }
    },
    changeLov () {
      this.form.goodsList = [];
      this.form.orderList = [];
    },
    getVolume(v) {
      if (v.length && v.height && v.width) {
        return v.length * v.width * v.height;
      } else {
        return 0;
      }
    },
    tableRowClassName({row}) {
      return row.temporaryQty > row.waitQty ? 'warning-row' : '';
    },
    getTableData(data) {
      this.form.goodsList = data;
    },
    onImport() {
      this.$refs.ExcelImport.show();
    },
    // 选择关联采购单
    addPurchase() {
      this.isPurchase = true;
      this.$refs.dialogOrderList.show(this.form.orderList);
      // 清空商品信息
      this.form.goodsList = [];
    },
    // 无采购单入库
    onNoPurchase() {
      this.isPurchase = false;
      this.form.type = null;
      this.form.supplierCode = null;
      this.form.orderList = [];
      this.form.goodsList = [];
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    onChangeWarehouse(v, item) {
      this.form.warehouseName = item.name;
    },
    onChangeSupplier(v, item) {
      this.form.supplierName = item.name;
      // 清空商品列表
      this.form.goodsList = [];
    },
    onChangeLogisticsBusiness(v, item) {
      this.form.ogisticsBusinessCode = item?.code;
      this.form.logisticsBusinessName = item?.name;
    },
    // 选择收件地址
    onChangeRegionCascader(v) {
      if (v.length > 0) {
        this.form.countryName = v[0].label;
        this.form.countryCode = v[0].value;
        this.form.recipientProvince = v[1].label;
        this.form.recipientProvinceCode = v[1].value;
      }
    },
    // 添加入库商品
    addStorageShop() {
      // 判断是否关联采购单
      if (this.isPurchase && this.form.orderList.length === 0) {
        this.msgError(this.$t('BusinessPurchaseComponentsCom.bjDialogText'));
        return;
      }
      // 判断是否选择供应商
      if (!this.form.supplierCode) {
        this.msgError(this.$t('BusinessPurchaseComponentsCom.rules.supplierCode'));
        return;
      }
      this.$refs[this.isPurchase ? 'dialogPurchaseGoodsList' : 'dialogGoodsList'].show(
        this.form.goodsList,
      );
    },
    // 添加采购单、商品回调相关
    onAddDialogConfirm(data) {
      /*
        关联选中的采购单信息带入填充下方基础信息；
        入库类型：采购入库/采购退货出库（默认 不可更改）
        供应商：关联采购单上供应商（默认不可更改）
       */
      if (this.isPurchase && data.length !== 0) {
        if (data.length === 1) {
          this.form.purchaseCode = data[0].code;
          this.form.applyCode = data[0].applyCode;
          // 入库类型赋值
          this.form.type = this.enter ? 'PURCHASE_STOCKIN' : 'PURCHASE_STOCKOUT';
          // 供应商赋值
          this.form.supplierCode = data[0].supplierCode;
          this.form.supplierName = data[0].supplierName;
          this.form['orderList'] = data;
          const goodsList = [];
          data[0].goodsList.forEach(item1 => {
            const result = data[0].rpcGoodsResVOS.find(item2 => item2.skuCode === item1.skuCode);
            if (result) {
              const mergedItem = {...result, ...item1, grossPriceAfterDisc: 0, totalPrice: 0, taxUnitPrice: 0, code: data[0].code, discount: 0.00, taxCode: this.form.purchaseType === 'COMMON' ? 'p2' : 'p1', uomCode: 'Manual', temporaryQty: 0, warehouse: 'SEL2' };
              goodsList.push(mergedItem);
            }
          });
          this.form['goodsList'] = goodsList;
        } else {
          const supplierCode = data[0].supplierCode;
          const result = data.every(v => v.supplierCode === supplierCode);
          const purchaseCodeList = [];
          const applyCodeList = [];
          data.forEach(item => {
            purchaseCodeList.push(item.code);
            applyCodeList.push(item.applyCode);
          });
          if (result) {
            this.form.purchaseCode = purchaseCodeList.join(',');
            this.form.applyCode = applyCodeList.join(',');
            // 入库类型赋值
            this.form.type = this.enter ? 'PURCHASE_STOCKIN' : 'PURCHASE_STOCKOUT';
            // 供应商赋值
            this.form.supplierCode = data[0].supplierCode;
            this.form.supplierName = data[0].supplierName;

            data.sort((a, b) => a.code.localeCompare(b.code));
            const goodsList = [];
            data.forEach(item => {
              item.goodsList.forEach(item1 => {
                const result2 = item.rpcGoodsResVOS.find(item2 => item2.skuCode === item1.skuCode);
                if (result2) {
                  const mergedItem = { ...result2, ...item1, grossPriceAfterDisc: 0, totalPrice: 0, taxUnitPrice: 0, code: item.code, discount: 0.00, taxCode: this.form.purchaseType === 'COMMON' ? 'p2' : 'p1', uomCode: 'Manual', temporaryQty: 0, warehouse: 'SEL2' };
                  goodsList.push(mergedItem);
                }
              });
            });
            this.form.goodsList = goodsList;
            this.form['orderList'] = data;
          } else {
            this.msgError(this.$t('BusinessPurchaseComponentsCom.msgError1'));
            this.form.orderList = [];
            return false;
          }
        }
      }
    },
    onAddDialogGoodsConfirm(data) {
      this.form['goodsList'] = data.map(e => {
        return {
          ...e,
          remark: this.enter ? null : e.remark,
          taxPrice: maxToFixed((e.planQty || 0) * (e.taxUnitPrice || 0), 5),
        };
      });
    },
    // changeTaxUnitPrice(row, index) {
    //   this.form.goodsList.splice(index, 1, {
    //     ...row,
    //     taxUnitPrice: maxToFixed(row.taxUnitPrice, 5),
    //     taxPrice: maxToFixed(row.planQty * row.taxUnitPrice, 5),
    //   });
    // },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    onDelete(row, index) {
      this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          row
            ? this.form.goodsList.splice(index, 1)
            : (this.form.goodsList = this.form.goodsList.filter(
              row => !this.selection.map(e => e.skuCode).includes(row.skuCode),
            ));
        })
        .catch(() => {});
    },
    handleClose() {
      this.$emit('reFresh');
    },
    // 提交相关
    handleConfirm() {
      // 判断是否关联采购单
      if (this.isPurchase && this.form.orderList.length === 0) {
        this.msgError(this.$t('BusinessPurchaseComponentsCom.bjDialogText'));
        return;
      }
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.form.goodsList.length === 0) {
            this.msgError(this.$t('BusinessPurchaseComponentsCom.msgError'));
            return;
          }
          let message = '';
          for (const item of Object.values(this.form.goodsList)) {
              if (!item.temporaryQty || !item.taxUnitPrice) {
                    this.msgError(this.$t('BusinessPurchaseComponentsPur.msgError4'));
                    return;
              }
              if (item.temporaryQty > item.waitQty) {
                  message += `${item.skuCode} ${this.$t('BusinessPurchaseComponentsPur.confirmText1')}：${item.waitQty}, ${this.$t('BusinessPurchaseComponentsPur.confirmText2')}：${item.temporaryQty}; `;
              }
            }

          const freight = {
            freightTax: this.freight[0].totalTaxAmount,
            freight: this.freight[0].netAmount,
            totalFreight: this.freight[0].grossAmount,
            taxRate: this.freight[0].tax,
            taxCode: this.freight[0].taxGroup,
          };
          let API_DATA = this.$lodash.clone(this.form);
          if (this.form.purchaseType !== 'COMMON') {
            API_DATA = {
              ...API_DATA,
              ...freight
            };
          }
          API_DATA.goodsList = API_DATA.goodsList.map(row => {
            return {
              alreadyQty: 0,
              planQty: row.temporaryQty,
              skuCode: row.skuCode,
              skuName: row.skuName,
              taxUnitPrice: row.taxUnitPrice,
              waitQty: 0,
              dataFaultToleranceQty: 0,
              discount: row.discount,
              purchaseCode: row.code,
              taxCode: row.taxCode,
              grossPriceAfterDisc: row.grossPriceAfterDisc,
              totalPrice: row.totalPrice,
              warehouseCode: row.warehouse,
              uomCode: row.uomCode,
            };
          });
          if (this.isEdit) {
            API_DATA['_innerMap'] = {};
          }
          const apiName = (this.isEdit ? 'put' : 'add') + (this.enter ? 'Stockins' : 'Stockouts');
          if (message.length > 0) {
            this.$confirm(message, this.$t('toast.hintText'), {
              confirmButtonText: this.$t('toast.okText'),
              cancelButtonText: this.$t('toast.cancelText'),
              type: 'warning',
            }).then(() => this.sendApi(apiName, API_DATA)).catch(() => {});
          } else {
            this.sendApi(apiName, API_DATA);
          }
        } else {
          return false;
        }
      });
    },
    sendApi(apiName, API_DATA) {
      purchaseApi[apiName](API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.handleClose();
            this.form = defaultForm();
          }, 500);
        }
      });
    },
    async getData() {
      const res1 = await purchaseApi[this.enter ? 'getStockinsDetail' : 'getStockoutsDetail']({
        id: this.$route.query.id,
        code: this.$route.query.code,
      });
      // 地址回显
      // if (res1.recipientProvinceCode && res1.recipientCityCode && res1.recipientDistrictCode) {
      if (res1.countryCode && res1.recipientProvinceCode) {
        this.regionList = [
          Number(res1.countryCode),
          Number(res1.recipientProvinceCode),
        ];
      }
      // 是否关联采购单
      this.isPurchase = !!res1.purchaseCode;
      // 有关联采购单需要获取采购单数据
      const res2 = await purchaseApi['getByPurchaseCodeList']({
          purchaseCode: res1.purchaseCode,
          page: 1,
          size: 20
        });
      res1.orderList = res2.content;
      this.form = res1;
      this.form.goodsList = res1.goodsList.map(v => {
        return {
          ...v,
          ...v.rpcGoodsResVO,
          isSame: true,
          warehouse: v.warehouseCode,
        };
      });
      this.freight[0].totalTaxAmount = res1.freightTax;
      this.freight[0].netAmount = res1.freight;
      this.freight[0].grossAmount = res1.totalFreight;
      this.freight[0].tax = res1.taxRate;
      this.freight[0].taxGroup = res1.taxCode;
    },
    text(type) {
      let text = this.$t('BusinessPurchaseComponentsCom.storage');
      if (!this.enter) {
        text = this.$t('BusinessPurchaseComponentsCom.returnGoods');
        if (type) text += this.$t('BusinessPurchaseComponentsCom.outWarehouse');
      }
      return text;
    },
  },
};
</script>
<style scoped>
.el-form-item--mini.el-form-item {
  margin: 15px 0;
}
::v-deep .el-table .warning-row{
  color: red!important;
}
</style>
